module.exports = __webpack_public_path__ + "static/media/barbecue.d2040b4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/icons/barbecue.svg
// module id = ./src/resources/images/icons/barbecue.svg
// module chunks = 0